angular.module('natgeo').controller('Level1SplashScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 
function Level1SplashScreen($scope, element, ScreenFactory, manager, container, SoundEngine)
{
	var screen = ScreenFactory( 'level1_splash', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('level1SplashGearIntro', {
			keyframe: {
				'0,100': {
					opacity: 0
				},
				'30,70': {
					opacity: 1
				}
			}
		}, {
			delay: 1000,
			duration: 2500
		});

		anim8.save('level1SplashGearOutro', {
			initial: {
				opacity: 0
			}
		}, {
			duration: 1
		});

		anim8.save('level1SplashRobotIntro', {
			keyframe: {
				from: {
					translate: {x: 25, y: -25},
					opacity: 0
				},
				to: {
					translate: 0,
					opacity: 1
				}
			},
			units: {
				translate: '%'
			}
		});

		anim8.save('level1SplashRobotOutro', {
			keyframe: {
				from: {
					translate: 0,
					opacity: 1
				},
				to: {
					translate: {x: -25, y: 25},
					opacity: 0
				}
			},
			units: {
				translate: '%'
			}
		});
	});

	// How long to wait after intro before progressing to the next screen (in milliseconds).
	var WAIT_TIME = 5 * 1000;

	// Wait X seconds after intro has finished before progressing to the next screen
	screen.on('introEnd', function()
	{
		setTimeout(function()
		{
			$scope.begin(); 

		}, WAIT_TIME);
	});

	// Beginning of the screen, play the whip!
	screen.on('introBegin', function()
	{
		SoundEngine.play( 'click', {delay:2200} );
		SoundEngine.play( 'click', {delay:3200} );
		SoundEngine.play( 'whip',  {delay:4500} );
	});
	
	// The next screen is the office screen
	$scope.begin = function()
	{
		manager.transition('level1_office');
	};
	
}]);